<template>
  <div>
    <!-- <b-card class="rounded-xl">
      <div>
        <NewPage />
      </div>
    </b-card> -->
    <b-card v-if="!shownewpage">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6>
        <AddPageDetail />
        <template slot="footer">
          <base-button type="primary">SAVE CHANGES</base-button>
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal>
      <!-- <AddPageDataSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    /> -->

      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Pages
          </h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <base-button
          outline
          type="success"
          class="flex"
          @click="shownewpage = true"
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Pages
        </base-button>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class=" cursor-pointer  mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
        :data="Data"
      >
        <el-table-column label="Sr no." prop="srno" min-width="100px" sortable>
        </el-table-column>
        <el-table-column
          label="Titile"
          min-width="150px"
          prop="category"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black font-medium">{{ row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Sub Title"
          min-width="150px"
          prop="subtitle"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black ">{{ row.subtitle }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Description"
          min-width="270px"
          prop="orderno"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black ">{{ row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Image Url"
          min-width="170px"
          prop="imgurl"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black ">{{ row.imgurl }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tags" min-width="170px" prop="tags" sortable>
          <template v-slot="{ row }">
            <span class=" text-black ">{{ row.tags }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Action" min-width="190px">
          <div class="flex items-center">
            <div class="flex items-center mr-4 cursor-pointer">
              <feather-icon
                @click="editModal = true"
                block
                icon="Edit3Icon"
                svgClasses="w-5"
              ></feather-icon>
            </div>
            <div class="flex items-center cursor-pointer">
              <feather-icon icon="Trash2Icon" svgClasses="w-5"></feather-icon>
            </div>
          </div>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="50"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";
import Data from "./components/Data";
import AddPageDetail from "./components/AddPageDetail";
import AddPageDataSidebar from "./components/AddPageDataSidebar.vue";
import NewPage from "./components/NewPage";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    AddPageDetail,
    AddPageDataSidebar,
    NewPage
  },
  data() {
    return {
      Data,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      shownewpage: false
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
